<script setup>
import { computed } from 'vue';
import { docStatusTone } from '@rm-ui/levelling/levellingMeta';

const props = defineProps({
  value: { type: String, default: '' },
});

const tone = computed(() => docStatusTone(props.value));
</script>

<template>
  <span class="cc-docstat" :class="'cc-docstat--' + tone">{{ value || '—' }}</span>
</template>

<style lang="scss" scoped>
/* Document status is a quiet second axis — it must never compete with the
   evaluation-status pill, so it renders as plain tinted text. */
.cc-docstat {
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;

  &.cc-docstat--muted { color: var(--cc-text-3, #8a93a3); }
  &.cc-docstat--warn { color: var(--cc-warn-fg, #8a6a00); }
  &.cc-docstat--ok { color: var(--cc-ok-fg, #1f7a53); }
}
</style>
